import { ready } from 'brei-project-utils';
import { Splide } from '@splidejs/splide';

const main = {

	init() {

		// Set cookie consent stuff
		main.consentStatus = localStorage.getItem('consentsToCookies');
		main.consentModal = document.querySelector('.cookie-consent');
		main.consentButtons = document.querySelectorAll('.cookie-consent .btn');

		// Video play toggle
		document.querySelector('.thrift-score__toggle').addEventListener('click', main.toggle);

		// OnIntersect animations for list cards
		main.observer = new IntersectionObserver(main.animate, { root: null, rootMargin: '-50px 0%', threshold: 0 });

		document.querySelectorAll('.start-thrifting__item, .upload-your-designs__image').forEach(function(element) {
			element.classList.add('waiting');
			main.observer.observe(element);
		});

		// Wire up upload form
		document.querySelector('#upload').addEventListener('click', main.formOpen);
		document.querySelector('.upload-form__close').addEventListener('click', main.formClose);

		// Carousel for lookbook
		main.skins = new Splide('.find-your-look__carousel', {
			arrows: true,
			drag: true,
			gap: '16px',
			pagination: false,
			perPage: 1,
			type: 'loop',
			fixedWidth: '336px',
			breakpoints: {
				1023: {
					fixedWidth: '264px',
					gap: '12px',
				}
			}
		}).mount();

		// Start animation
		document.querySelector('.thrift-score__upper').classList.add('animating');

		// Release screen lock after 2000ms
		window.setTimeout(function() {
			document.querySelector('body').classList.remove('locked');
			main.consent();
		}, 2000);

	},

	animate(entries) {
		entries.forEach(entry => {
			if(entry.isIntersecting) {
 				entry.target.classList.remove('waiting');
 				main.observer.unobserve(entry.target);
			}
		});
	},

	consent() {
		if(main.consentStatus === null) {
			main.consentModal.setAttribute('aria-hidden', 'false');
			main.consentButtons.forEach(function (button) {

				button.addEventListener('click', function(event) {
					// 0. Get the value of the button clicked ("true" or "false")
					const userChoice = event.currentTarget.value;
					const isGranted = (userChoice === 'true');
					console.log(isGranted);

					// 1. Save the choice to localStorage (Original functionality)
					localStorage.setItem('consentsToCookies', '{"value":' + userChoice + '}');

					// 2. Hide the modal (Original functionality)
					main.consentModal.setAttribute('aria-hidden', 'true');
					main.consentModal.style.display = 'none';

					// 3. Set conset properties based on button click
					const consentUpdate = {
						'ad_storage': isGranted ? 'granted' : 'denied',
						'analytics_storage': isGranted ? 'granted' : 'denied',
						'ad_user_data': isGranted ? 'granted' : 'denied',
						'ad_personalization': isGranted ? 'granted' : 'denied',
						'functionality_storage': 'granted', // Typically granted						
						'personalization_storage': isGranted ? 'granted' : 'denied',
						'security_storage': 'granted' // Typically granted
					};

					// 4. Push updated consent status to GTM data layer
					// This command updates the consent state in Google Consent Mode (v2)
					window.dataLayer = window.dataLayer || [];
					if (typeof window.gtag === 'function') {
					  window.gtag('consent', 'update', consentUpdate);
					} else {
					  window.dataLayer.push(['consent', 'update', consentUpdate]);
					}
					
					// follow-up event that GTM triggers on
					window.dataLayer.push({ event: 'consent_granted_update', consent: consentUpdate });
					
				});
			});
		}
	},

	formClose() {
		document.querySelector('.upload-form').close();
	},

	formOpen() {
		document.querySelector('.upload-form').showModal();
	},

	toggle(event) {
		event.preventDefault();
		let pressed = event.currentTarget.getAttribute('aria-pressed');
		let label = event.currentTarget.querySelector('span').innerHTML;
		pressed = (pressed === 'true') ? 'false' : 'true';
		label = label.indexOf('Play') > -1 ? label.replace('play', 'pause') : label.replace('pause', 'play');
		event.currentTarget.setAttribute('aria-pressed', pressed);
		event.currentTarget.querySelector('span').innerHTML = label;
		if (pressed === 'true') {
			event.currentTarget.closest('div').querySelector('video').pause();
		} else {
			event.currentTarget.closest('div').querySelector('video').play();
		}
	}

};

ready(function () {
	main.init();
});
